import { IApplicationContext } from '../../../types/applicationContext';
import {
  fetchReceiptDetailsGet,
  type TReceiptDetailsGetResponse,
} from '../../../repositories/dailyrent/v1/receipt-details/get';

export async function fetchFormInitialData(context: IApplicationContext) {
  const { httpApi, logger } = context;

  try {
    const response: TReceiptDetailsGetResponse = await fetchReceiptDetailsGet({
      httpApi,
    });

    return response as TReceiptDetailsGetResponse;
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
